import { isAdmin, isEnterprise } from '@vacinas-net/shared'
import { useSelector } from '../state/store'

export const usePermissions = () => {
  const isLogged = useSelector((state) => state.auth.isLogged)
  const roles = useSelector((state) => state.auth.roles)

  return {
    isAdmin: () => isLogged && isAdmin(roles),
    isEnterprise: () => isLogged && isEnterprise(roles),
  }
}
